var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasTank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gas_tank_icon",
    "data-name": "Gas tank icon",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    transform: "translate(0 32) rotate(-90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(6.322 5.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M.965,21.333A.965.965,0,0,1,0,20.368v-.619a.965.965,0,0,1,.965-.965H12.813a.965.965,0,0,1,.965.965v.619a.965.965,0,0,1-.965.965Zm.107-3.641V1.34A1.334,1.334,0,0,1,1.465.393,1.334,1.334,0,0,1,2.412,0h9.007a1.338,1.338,0,0,1,1.234.819,1.335,1.335,0,0,1,.106.521c-.027,10.089.062,11,0,16.352ZM3.553,3.6V7.4a.645.645,0,0,0,.643.643H9.5a.645.645,0,0,0,.643-.643V3.6A.645.645,0,0,0,9.5,2.954H4.2A.645.645,0,0,0,3.553,3.6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M7.212,12.627h.362a2.007,2.007,0,0,1,1.418.588,1.984,1.984,0,0,1,.588,1.418v2a1.055,1.055,0,0,0,2.111-.008V12.062H10.55a.475.475,0,0,1-.475-.475V6.8a.48.48,0,0,1,.272-.431L13.282,5V3.931l-2.95-1.518a.475.475,0,0,1,.433-.846l3.21,1.652a.473.473,0,0,1,.258.421v7.946a.476.476,0,0,1-.475.475H12.746v4.565a2.1,2.1,0,0,1-.618,1.491,2.113,2.113,0,0,1-3.438-.67,2.126,2.126,0,0,1-.161-.664h0V14.738A1.058,1.058,0,0,0,7.47,13.683H7.212Z",
    transform: "translate(5.547 -0.604)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasTank);
export default __webpack_public_path__ + "static/media/gas-tank.d6d152fb.svg";
export { ForwardRef as ReactComponent };